export const siteSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://apexvision.ai/#org"
      },
      {
        "@type": "WebSite",
        "@id": "https://chat.apexvision.ai/#site",
        "url": "https://chat.apexvision.ai/",
        "name": "Apex Vision AI Chat Assistant",
        "publisher": { "@id": "https://apexvision.ai/#org" },
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://chat.apexvision.ai/?s={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }
    ]
  };

  export function pageSchema({ path, title, description }) {
    const base = "https://chat.apexvision.ai";
    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${base}${path}#page`,
          "url": `${base}${path}`,
          "name": title,
          "description": description,
          "inLanguage": "en",
          "isPartOf": { "@id": "https://chat.apexvision.ai/#site" }
        },
        {
          "@type": "SoftwareApplication",
          "@id": `${base}${path}#app`,
          "name": title,
          "applicationCategory": "WebApplication",
          "operatingSystem": "All",
          "url": `${base}${path}`,
          "publisher": { "@id": "https://apexvision.ai/#org" }
        }
      ]
    };
  }

  export function breadcrumbSchema({ path, title }) {
    const base = "https://chat.apexvision.ai";
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${base}/`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": title,
          "item": `${base}${path}`
        }
      ]
    };
  }